import { getSettingHelpCenterAIChatbot } from "../settings/getSettingHelpCenterAIChatbot";
import { getSettingHelpCenterAIChatbotNativeMobile } from "../settings/getSettingHelpCenterAIChatbotNativeMobile";
import { isMobileApp } from "./isMobileApp";
export var chatbotEnabled = function chatbotEnabled() {
  if (isMobileApp()) {
    return getSettingHelpCenterAIChatbotNativeMobile();
  }
  return getSettingHelpCenterAIChatbot();
};